const vitekPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-1-VITEK.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-2-VITEK-2.pdf",
        module: 2
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-3-VITEK-3.pdf",
        module: 3
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-4-VITEK-4.pdf",
        module: 4
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-5-VITEK-5.pdf",
        module: 5
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-6-VITEK-6.pdf",
        module: 6
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo-7-VITEK-7.pdf",
        module: 7
    },
];

const filmarrayPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 1-FILM ARRAY.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 2-FILM ARRAY.pdf",
        module: 2
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 3-FILM ARRAY.pdf",
        module: 3
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 4-FILM ARRAY.pdf",
        module: 4
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 5-FILM ARRAY.pdf",
        module: 5
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 6-FILM ARRAY.pdf",
        module: 6
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 7-FILM ARRAY.pdf",
        module: 7
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Modulo 8-FILM ARRAY.pdf",
        module: 8
    }
];

const bartalecPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/UI-R_DOC_Modulo1_07-09-22_LPD.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/UI-R_DOC_Modulo2_07-09-22_LPD.pdf",
        module: 2
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/UI-R_DOC_Modulo3_07-09-22_LPD.pdf",
        module: 3
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/UI-R_DOC_Modulo4_07-09-22_LPD.pdf",
        module: 4
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/UI-R_DOC_Modulo5_07-09-22_LPD.pdf",
        module: 5
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/UI-R_DOC_Modulo6_07-09-22_LPD.pdf",
        module: 6
    },
];

const VidasPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/1.Generalidades VidasFamily.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/2Principio del Instrumento.pdf",
        module: 2
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/3conceptoVIDAS.pdf",
        module: 3
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/CalibraciónreactivosVIDAS.pdf",
        module: 4
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/importanciafasepreanaltica.pdf",
        module: 5
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/6errorescomunes.pdf",
        module: 6
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/7reportedecasosalCATB.pdf",
        module: 7
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/8rutinadeprocesamientoymantenimientosVidasPC.pdf",
        module: 8
    },
    
];


const Vidas3Pdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/1.Generalidades VidasFamily.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/2Principio del Instrumento.pdf",
        module: 2
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/3conceptoVIDAS.pdf",
        module: 3
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/CalibraciónreactivosVIDAS.pdf",
        module: 4
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/importanciafasepreanaltica.pdf",
        module: 5
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/6errorescomunes.pdf",
        module: 6
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/7reportedecasosalCATB.pdf",
        module: 7
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/8RutinadeprocesamientoymantenimientosVidas3.pdf",
        module: 8
    },
];

const MiniVidasPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/1.Generalidades VidasFamily.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/2Principio del Instrumento.pdf",
        module: 2
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/3conceptoVIDAS.pdf",
        module: 3
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/CalibraciónreactivosVIDAS.pdf",
        module: 4
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/importanciafasepreanaltica.pdf",
        module: 5
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/6errorescomunes.pdf",
        module: 6
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/7reportedecasosalCATB.pdf",
        module: 7
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/8rutinadeprocesamientoymantenimientosMiniVidas.pdf",
        module: 8
    },
];

const previcolorPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Previcolor_ Presentacion2023.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/Previcolor_ Presentacion2023.pdf",
        module: 2
    },
    
];

const ralstainerPdfs = [
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/PRESENTACIÓN RAL MICOBACTERIAS.pdf",
        module: 1
    },
    {
        pdf: "https://api.elearningclinicalbmxsystems.com/dowloadpdf/PRESENTACIÓN RAL MICOBACTERIAS.pdf",
        module: 2
    },
    
];



export const getPdfs = (module, course) => { 
    console.log(course)
    if(course == 2) {
        return vitekPdfs.find((item) => item.module == module).pdf;
    } else if (course == 3) {
        return filmarrayPdfs.find((item) => item.module == module).pdf;
    } else if(course == 4) {
        return bartalecPdfs.find((item) => item.module == module).pdf;
    }else if(course == 5) {
        return VidasPdfs.find((item) => item.module == module).pdf;
    }else if(course == 6) {
        return Vidas3Pdfs.find((item) => item.module == module).pdf;
    }else if(course == 8) {
        return previcolorPdfs.find((item) => item.module == module).pdf;
    }else if(course == 9) {
        return ralstainerPdfs.find((item) => item.module == module).pdf;
    }
     else {
        return MiniVidasPdfs.find((item) => item.module == module).pdf;
    }
}
